export const getIsSelectionImportLoading = (store: Store) => store.selectionImport.isLoading;
export const getHasSelectionImportCompleted = (store: Store) => store.selectionImport.hasCompleted;
export const getHasSelectionImportFailed = (store: Store) => store.selectionImport.hasFailed;
export const getSelectionImportErrors = (store: Store) => store.selectionImport.errors;
export const getSelectionImportWarning = (store: Store) => store.selectionImport.warning;
export const getWasSelectionClosedDuringImport = (store: Store) => store.selectionImport.wasSelectionClosed;
export const getWasSelectionRemovedDuringImport = (store: Store) => store.selectionImport.wasSelectionRemoved;
